query GetAuthenticationUser($email: String!) {
  authenticationUser(email: $email) {
    id
  }
}

query GetAuthenticationUserBlockedStatus($email: String!) {
  authenticationUserBlockedStatus(email: $email) {
    blocked
  }
}

mutation UnblockAuthenticationUser($email: String!) {
  unblockAuthenticationUser(email: $email) {
    authenticationUser {
      blocked
    }
  }
}
